import { Row, Col } from 'antd';
import { 
    AppstoreOutlined, 
    CheckCircleOutlined, 
    CloseCircleOutlined 
} from '@ant-design/icons';
import StatCard from '@/components/UI/Cards/StatCard';
import { useEventData } from '../hooks/useEventData';

/**
 * Event card component displaying event statistics
 * Uses real data from the API
 */
const EventCard = () => {
    // Use custom hook for event data
    const { 
        totalEvents,
        activeEvents,
        inactiveEvents,
        isLoading, 
        isError,
        error 
    } = useEventData();

    if (isLoading) {
        return (
            <Row gutter={[16, 16]}>
                {[1, 2, 3].map((index) => (
                    <Col xs={24} sm={12} md={8} key={index}>
                        <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center space-x-4 shadow-sm">
                            <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"></div>
                            <div className="flex flex-col flex-1">
                                <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-20"></div>
                                <div className="h-6 bg-gray-200 rounded animate-pulse w-12"></div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        );
    }

    if (isError) {
        return (
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
                        <p className="text-red-600">
                            Error loading catering packages data: {error?.message || 'Unknown error'}
                        </p>
                    </div>
                </Col>
            </Row>
        );
    }

    // Data configuration for catering package statistics
    const cardData = [
        {
            icon: AppstoreOutlined,
            title: "All Packages",
            count: totalEvents ?? 0,
            iconColor: "text-blue-600",
            iconBgColor: "bg-blue-100"
        },
        {
            icon: CheckCircleOutlined,
            title: "Active Packages",
            count: activeEvents ?? 0,
            iconColor: "text-green-600",
            iconBgColor: "bg-green-100"
        },
        {
            icon: CloseCircleOutlined,
            title: "Inactive Packages",
            count: inactiveEvents ?? 0,
            iconColor: "text-gray-600",
            iconBgColor: "bg-gray-100"
        }
    ];

    return (
        <Row gutter={[16, 16]}>
            {cardData.map((stat, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                    <StatCard
                        icon={stat.icon}
                        title={stat.title}
                        count={stat.count}
                        iconColor={stat.iconColor}
                        iconBgColor={stat.iconBgColor}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default EventCard;